import createTrigger from '../../../../../vendor/react-use-trigger/index'

export const showMenu = createTrigger()
export const hideMenu = createTrigger()
export const toggleMenu = createTrigger()

export const setPageHeight = createTrigger()
export const setProfileSwipe = createTrigger()
